fragment TextAutomation on TextMessageAutomation {
    id
    content
    position
    stage {
        id
        name
    }
    sendFromUser {
        id
        initials
        avatarUrl
        name
    }
    delay {
        unit
        timespan
    }
}
